import React, { FC, useEffect } from 'react'
import { observer } from 'mobx-react'
import { IonHeader, IonPage, useIonViewDidEnter, useIonViewWillEnter } from '@ionic/react'
import { checkoutMobx, preOrderingMobx, storeMobx, timePickMobx, memberMobx, deliveryMobx } from '@mobxStore'
import { cartMobx, orderMobx, restaurantCenter } from 'restaurant'
import MktController from '@ctrls/mktController'
import { Icon } from '@cps'
import { CartCheck, CartActions, CartItems, CartFooter, CheckoutItems, CartRemark, CartPerson, CartOrderSwapBuys, DiscountOrderSwapBuy, TablePersonRemark } from './component'
import CartPreOrderFooter from './component/CartPreOrderFooter'
import OrderAPI from '@api/order.api'
import { TEEatType } from 'restaurant/mobx/store.mobx'
import { DiningNumberPickController } from '@ctrls/index'
import './index.scss'

interface IProps { }

const Cart: FC<IProps> = ({ }) => {
  const getMemberNiceGuy = async () => {
    const hasLbs = restaurantCenter.config?.lbs?.lat && restaurantCenter.config?.lbs?.lng
    // 后付费 并且开启对应就餐方式
    const mustLoc = cartMobx.info.payMode && ((Config.codeType === 'table' && storeMobx.info.posAllConfirmOrders) || (Config.codeType === 'brand' && storeMobx.info.mobilePickupAllConfirmOrders))
    // 开启了需要定位
    if (mustLoc) {
      let isNiceGuy = 0
      try {
        const res: any = await OrderAPI.isNiceGuy(cartMobx.info.eatType)
        if (!res.error) {
          isNiceGuy = res.result.niceGuy
        }
      } catch (error) {
      }
      if (isNiceGuy) {
        try {
          if (!hasLbs) await MktController.openLBS(false)
          const { distance } = storeMobx.info
          cartMobx.setDistance(distance)
        } catch (error) {
          console.log(error, 'error')
        }
      }
    } else {
      cartMobx.setDistance()
    }
  }

  const calcExpressFee = () => {
    /** 配送费重算 */
    if (cartMobx.info.eatType === TEEatType.delivery) {
      cartMobx.setExpressPrice(deliveryMobx.expressFee)
      cartMobx.setExpressList()
    }
  }

  /** 就餐人数用户 */
  const showDiningModal = async () => {
    const isCanDinein = storeMobx.info.storeId && cartMobx.info.eatType === 'dinein' && !cartMobx.info.person && !Config.queueId
    if (isCanDinein) {
      await DiningNumberPickController.showPicker()
    }
  }

  useEffect(() => {
    setTimeout(() => {
      showDiningModal()
    }, 200)
  }, [cartMobx.info.eatType])

  useIonViewWillEnter(() => {
    timePickMobx.resetCartItems(true)
    checkoutMobx.resetDineinTogos()
  }, [])

  useIonViewDidEnter(() => {
    getMemberNiceGuy()
    checkoutMobx.setGuideRegister(!memberMobx?.brandConfig?.openIdSignMember)
    calcExpressFee()
  }, [])

  return (
    <IonPage className='cart-page'>
      {window.MEMBERISBUSY && (
        <IonHeader>
          <div className='error-footer-wrapper'>
            <Icon name='dengpao' />
            <span>{i18n.t('mkt.memberIsBusy.checkout')}</span>
          </div>
        </IonHeader>
      )}
      <CartCheck>
        {
          !orderMobx.viewOrder.isWait ? (
            <>
              <CartActions />
              <CartItems />
              <CartOrderSwapBuys />
            </>
          ) : (
            <TablePersonRemark />
          )
        }
        {
          !cartMobx.needPack && (
            <>
              <CheckoutItems />
              <DiscountOrderSwapBuy />
              <CartPerson />
              <CartRemark />
            </>
          )
        }
      </CartCheck>
      {/* 预点单底部按钮 */}
      {preOrderingMobx.checkPreOrder ? <CartPreOrderFooter /> : <CartFooter />}
    </IonPage>
  )
}

export default observer(Cart)
